import { ConfigurationValues } from '@cutr/constants/windows/windows';
import { CONFIGURATIONS_OPTIONS } from '@cutr/constants/windows/windows-configurations.ts';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { Label } from '@/windows/primitives/Label';

import { GridSelectModal } from '../../GridSelectModal';
import { unboxLabel } from '../Configurations';
import { ConfigurationComponent } from '.';

const WindowSillsConfigurationInput = () => {
  const { t } = useTranslation();
  const labelId = useId();
  const inputId = useId();

  const windowSillConfigs = CONFIGURATIONS_OPTIONS.windowSills.options;

  const windowSillsOptions = windowSillConfigs.map((config) => ({
    config,
    imagePath: `/sorpetaler/windowSills/${config.value}.jpg`,
  }));

  return (
    <>
      <Label id={labelId} htmlFor={inputId}>
        {t(`windows.configurations.windowSills.label`)}
      </Label>
      <GridSelectModal
        configurationKey="windowSills"
        dispatchAction="SET_WINDOW_SILLS"
        options={windowSillsOptions}
        buttonId={inputId}
      />
    </>
  );
};

const config: ConfigurationComponent<'windowSills'> = {
  key: 'windowSills',
  input: <WindowSillsConfigurationInput />,
  display: (value: ConfigurationValues['windowSills']) => (
    <span>{unboxLabel(value?.label)}</span>
  ),
};

export default config;
